<template>
  <v-app id="app">
    <core-view/>
  </v-app>
</template>

<script>
import View from './components/View';

export default {
    name: 'App',
    components: {
        'core-view': View,
    },
    beforeCreate() {
        if (this.$store.state.accessToken) {
            this.$http.defaults.headers.common['Authorization'] = this.$store.state.accessToken;
        }
        // else {
        //     this.$router.push({ name: "empty" });
        // }
    },
}
</script>

<style lang="scss">
@import './style/index.scss';
</style>
